// @ts-check

import cleanSource from '@/helpers/clean-source'
import mapKeys from '@/helpers/map-keys'
import * as _ from 'lodash-es'

const vehicleKeysMap = {
  registration_number: 'registrationNumber',
  vehicle_type: 'vehicleType',
  is_business_asset: 'isBusinessAsset',
  is_company_owned: 'isOwnedByBusiness',
  subject_to_license: 'isSubjectToLicence',
  rejection_reason: 'rejectionReason',
  removal_reason: 'removalReason',
  can_edit: 'canEdit',
  can_remove: 'canRemove',
  replacement_vehicle_id: 'replacementVehicleId',
  removal_description: 'removalDescription'
}

/**
 * Serializes a vehicle objct before sending it to the API
 *
 * @param {Object} vehicleObject
 * @returns {Object}
 */
export function serialize(vehicleObject) {
  const vehicle = cleanSource({ ...vehicleObject })

  if (_.has(vehicle, 'registrationNumber')) {
    vehicle.registration_number = vehicle.registrationNumber
    delete vehicle.registrationNumber
  }

  if (_.has(vehicle, 'vehicleType')) {
    vehicle.vehicle_type = vehicle.vehicleType
    delete vehicle.vehicleType
  }

  if (_.has(vehicle, 'isBusinessAsset')) {
    vehicle.is_business_asset = vehicle.isBusinessAsset
    delete vehicle.isBusinessAsset
  }

  if (_.has(vehicle, 'isOwnedByBusiness')) {
    vehicle.is_company_owned = vehicle.isOwnedByBusiness
    delete vehicle.isOwnedByBusiness
  }

  if (_.has(vehicle, 'isSubjectToLicence')) {
    vehicle.subject_to_license = vehicle.isSubjectToLicence
    delete vehicle.isSubjectToLicence
  }

  if (_.has(vehicle, 'removalReason')) {
    vehicle.removal_reason = vehicle.removalReason
    delete vehicle.removalReason
  }

  if (_.has(vehicle, 'replacementVehicleId')) {
    vehicle.replacement_vehicle_id = vehicle.replacementVehicleId
    delete vehicle.replacementVehicleId
  }

  if (_.has(vehicle, 'removalDescription')) {
    vehicle.removal_description = vehicle.removalDescription
    delete vehicle.removalDescription
  }

  delete vehicle.canEdit
  delete vehicle.canRemove
  delete vehicle.rejectionReason
  delete vehicle.state
  delete vehicle.attachments

  return vehicle
}

/**
 * Deserializes a vehicle object received from the API
 *
 * @param {VehicleResource} apiVehicle
 * @returns {Vehicle}
 */
export function deserialize(apiVehicle) {
  let vehicle = cleanSource({ ...apiVehicle })

  vehicle = mapKeys(apiVehicle, vehicleKeysMap)

  return vehicle
}

export default {}
